import Router from 'vue-router';
import Vue from 'vue';

Vue.use(Router);

const routes = [{
        path: '/',
        redirect: '/couponActivity'
    },
    {
        path: '/couponActivity',
        name: 'couponActivity',
        component: (reslove) => require(['../pages/couponActivity/index.vue'], reslove)
    },
    {
        path: '/download',
        name: 'pcDownload',
        component: (reslove) => require(['../pages/pcDownload/index.vue'], reslove)
    },
    {
        path: '/wapDownload',
        name: 'wapDownload',
        component: (reslove) => require(['../pages/wapDownload/index.vue'], reslove)
    },
    {
        path: '/nowechatpage',
        name: 'nowechatpage',
        component: (reslove) => require(['../pages/notWechatPage/index.vue'], reslove)
    },
    {
        path: '/compatibleWithPage',
        name: 'compatibleWithPage',
        component: (reslove) => require(['../pages/compatibleWithPage/index.vue'], reslove)
    }
];
const routerConf = new Router({
    mode: 'hash',
    routes // (缩写) 相当于 routes: routes
});
routerConf.beforeEach((to, from, next) => {
    if (window.location.href.indexOf('universelink.yftepay.com') != -1) {
        if (to.path !== '/wapDownload') {
            next('/wapDownload');
        } else {
            next();
        }
    } else {
        next();
    }
});
export default routerConf;